import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from "axios";
import update from "immutability-helper";
import isEmpty from "lodash/isEmpty";

import '../../../css/featured-products.css';

// Components
import Loader from "../../utils/Loader";
import AdminFeaturedProductsItem from './AdminFeaturedProductsItem';

// State
import { addRoute } from '../../../store/actions/route';
import { setpageTitle } from '../../../store/actions/siteInfo';
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class AdminFeaturedProducts extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoading: false,
            success: "",
            errors: {},
            featuredProducts: [],
            productSelectors1: [],
            productSelectors2: [],
            productSelectors3: [],
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Featured Products')
    }

    componentDidMount(){
        this.loadFeaturedProducts()
    }

    loadFeaturedProducts(){
        const { user } = this.props;
        this.setState(
            {isLoading: true},
            () => {
                const token = user.token;
                const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
                return axios
                    .get(REACT_APP_API_URL + "featured-products", { headers: AUTH_HEADER })
                    .then(response => {
                        if (response.status === 403 || (response.data.status && response.data.status === 403)) {
                            this.props.userLogout("admin");
                        } else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
                            this.setState({ isLoading: false, error: response.data.message });
                        } else {
                            this.setState({
                                isLoading: false,
                                featuredProducts: response.data.featured
                            });
                        }
                    })
                    .catch(err => {
                        if (err.response) {
                            this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
                        } else {
                            this.setState({ isLoading: false, error: err.message });
                        }
                    });
            }
        );
    }

    updateFeaturedProducts = () => {
        const { user } = this.props;
        const { featuredProducts } = this.state;
        this.setState(
			{
				success: ""
			},
			() => {
				let item = {products: []}
                if(!!featuredProducts[0] && !isEmpty(featuredProducts[0])) item.products.push(featuredProducts[0].id);
                if(!!featuredProducts[1] && !isEmpty(featuredProducts[1])) item.products.push(featuredProducts[1].id);
                if(!!featuredProducts[2] && !isEmpty(featuredProducts[2])) item.products.push(featuredProducts[2].id);

				const token = user.token;
				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
				return axios
					.post(REACT_APP_API_URL + "featured-products/", item, { headers: AUTH_HEADER })
					.then(response => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						} else {
							this.props.userLogout("admin");
                        }
                        
						if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
							if (!isEmpty(response.data.errors)) {
                                this.setState({
                                    errors: response.data.errors
                                });
                            }
                            //Success
						} else {
							this.setState({
								success: response.data.message
                            });
                            this.loadFeaturedProducts()
						}
					})
					.catch(err => {
                        this.setState({
                            errors: err
                        });
					});
			}
		);
    }

	handleProductSelect = (selection, index) =>{
		this.setState({
            featuredProducts: update(this.state.featuredProducts, {
                [index]: { $set: selection }
            })
		});
    }
    
    handleProductDelete(index){
		this.setState({
            featuredProducts: update(this.state.featuredProducts, {
                [index]: { $set: {} }
            })
		})
	}

    render() {
        const {featuredProducts, errors, success} = this.state;
        return (
            this.props.isLoading ? (
                <div className="pt1 pb1">
                    <Loader />
                </div> 
            ) : (
            <div>
                <h1>Featured Products</h1>
                <div className="fp-admin">
                    <AdminFeaturedProductsItem index={0} featuredProducts={featuredProducts[0]} 
                        handleProductSelect={(selection, index) => this.handleProductSelect(selection, index)}
                        handleProductDelete={(index) => this.handleProductDelete(index)}/>
                    <AdminFeaturedProductsItem index={1} featuredProducts={featuredProducts[1]} 
                        handleProductSelect={(selection, index) => this.handleProductSelect(selection, index)}
                        handleProductDelete={(index) => this.handleProductDelete(index)}/>
                    <AdminFeaturedProductsItem index={2} featuredProducts={featuredProducts[2]} 
                        handleProductSelect={(selection, index) => this.handleProductSelect(selection, index)}
                        handleProductDelete={(index) => this.handleProductDelete(index)}/>
                </div>
                {!!errors && !!errors.general && <div className="error msg_animate">{errors.general}</div>}
                {success && <div className="success msg_animate">{success}</div>}
                <button className="btn" onClick={() => this.updateFeaturedProducts()}>Update</button>
            </div>
            )
        )
    }
}

const mapStateToProps = (state) => {
    return {
		user: state.user.admin
    }
}

export default connect(mapStateToProps, { addRoute, setpageTitle, userTokenUpdate, userLogout })(AdminFeaturedProducts)


// WEBPACK FOOTER //
// ./src/components/admin/products/AdminFeaturedProducts.js